import { AppHelper } from "../appHelper.js"
import { AppBaseProps, CommonApp, Metadata } from "../core/components/commonApp.js";
import { General } from "../../siteManagement/general.js";
import { Helper } from "../core/util/helper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { Config } from "../core/config/config.js";
import { open } from "./editDashboard.js";
import { Statistic, StatisticField } from "../core/components/statistic.js"
import { PageTitleProps } from "../core/components/pageTitle.js";
import { DashboardStatistic } from "../generalSettings/dashboard.js";
import { MetadataTab } from "../core/components/tabStrip.js";
import { StringKeyDictionary } from "../commonInterfaces.js";
import React from "react";
export class HomeApp extends React.Component<AppBaseProps, any> {
    common = new AppHelper();
    translations: StringKeyDictionary<string>;
    noReminders = true;
    noBookmark = true;

    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);

        if ((this.props.metadata.hideMenu ?? true) || this.props.metadata.hideMenu) {
            General.Drawer.Left.disable();
        }

        let metaDataAdditional = this.props.metadata.additional.objects.filter((v) => v.name == "translations");
        this.translations = metaDataAdditional.length > 0 ? metaDataAdditional[0].data as any : null;
    }

    editUserDashboard = async () => {
        const update = await open();
        if (update) {
            setTimeout(() => { location.reload(); }, 1000)
        }
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    componentDidMount() {
        const tabs = this.props.metadata.tabs.filter((tab) => tab.visible)
        if (tabs.length == 1 && Config.settings.useStandardDashboard) {
            const { iconName, title } = tabs[0];
            const header = document.querySelector('div.sheet__title__label__text');
            header.innerHTML = `<label style="margin-right: 5px">
                                    ${title}
                                </label>
                                <i class="fa-regular fa-${iconName}" style="color: var(--main-menu-active-color);font-weight: 500;font-size: 1.3em;">
                                </i>`
            header.classList.remove("truncate")
        }
    }

    createGridSummary = (id, permission: number) => {
        return <Statistic field={{ statisticId: id, type: "", model: "", parameters: { canRead: permission > 0, canWrite: permission > 1, permission: permission } } as StatisticField}
            value={null}
            context={this.props.context}
            handleEval={this.common.evalAction}
            fullHeightLayout={true} />
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        const titleProps: PageTitleProps = {
            title: this.props.title,
        };
        return <CommonApp {...props} titleProps={titleProps} />;
    }
};

export class HomeHelper {
    private static getName = (statistic: DashboardStatistic) => {
        let name = statistic.TabName;
        const result = Helper.getTranslation(name);
        return Helper.isNullOrEmpty(result) ? name : result;
    }

    private static mapStatisticToTab = (statistic: DashboardStatistic): MetadataTab => {
        const tab = {
            title: this.getName(statistic),
            iconName: statistic.Icon,
            visible: statistic.Permission > 0,
            guid: statistic.Id,
            helpUrl: "",
            component: `createGridSummary('${statistic.StatisticId}',${statistic.Permission})`,
            type: "tab_with_module"
        };;
        return tab;
    }

    private static getMetadataByJSON = async () => {
        return await Helper.getMetaData("home");
    }

    private static generateMetadata = async () => {
        const { Data } = await HTTPService.get<JsonResultClass<DashboardStatistic[]>>("Dashboard/GetStatisticsForUser");
        const metaData: Metadata = {
            tabs: Data.map(this.mapStatisticToTab),
            additional: {
                objects: []
            },
            pageTitle: Helper.getTranslation("WebSMS.UserSettings.Dashboard.Dashboard"),
            hideMenu: false,
            menuDataSource: [
                {
                    text: Helper.getTranslation("CustomerPortal.Approval.Actions.Edit"),
                    icon: "pen",
                    onClick: "editUserDashboard()",
                    show: Data.length == 0 ? "false" : "true",
                    floating: true,
                    floatingColor: "#1976d2"
                }
            ],
            rightDrawerContainer: {
                visible: true,
                width: 400,
                multipleComponents: [
                    {
                        iconName: "question-circle",
                        iskey: "RIGHTDRAWER_COMPONENT_IFRAME",
                        moduleName: "app/core/components/iframe",
                        props: {
                            url: '{{helpBaseUrl}}/{{helpVersion}}/{{helpLanguage}}/grundlagen/dashboard'
                        },
                        renderAlways: true,
                        type: "rightdrawer_help",
                    }
                ]
            }
        };

        return metaData;
    }

    static getMetaDataForHome = async () => {
        if (Config.settings.useStandardDashboard && (!Config.user.isExternal || Config.settings.useDashboardForExternal))
            return await this.generateMetadata();
        else
            return await this.getMetadataByJSON();
    }
}

